import styled from 'styled-components';

export const CartItemButton = styled.button`
  color: ${Styles.color.primary};
  font-family: ${Styles.fontFamily.brand};
  border: 0;
  padding: 0.75rem;
`;
